import GeneralPayeeSettings from "@/models/Products/ProductSettings/DefaultSettings/GeneralPayee/GeneralPayeeSettings";

export default class AccountGeneralPayeeSettings extends GeneralPayeeSettings {
    overridden: boolean = false;
}